import React from 'react'
import styled from 'styled-components'

import type { IconProps } from '../icons'
import type { ChildrenProps, ClassNameProps } from '@root/shared/react'

type InputProps<T> = {
  startIcon?: React.FC<IconProps>
  input?: T
} & (T extends React.ComponentType
  ? React.ComponentProps<T>
  : React.InputHTMLAttributes<HTMLInputElement>) &
  ClassNameProps &
  ChildrenProps

const IconContainer = styled.div`
  color: #666666;
  margin-right: 6px;
  display: flex;
`

/**
 * @deprecated Use Input instead
 */
export const InputDeprecated = <T,>({
  className,
  startIcon,
  input,
  ...inputProps
}: InputProps<T>) => {
  const startIconEl = (() => {
    if (!startIcon) {
      return undefined
    }

    const Icon = startIcon

    return (
      <IconContainer>
        <Icon size={16} />
      </IconContainer>
    )
  })()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Input = input || ('input' as any)

  return (
    <Root className={className}>
      {startIconEl}
      <StyledInput as={Input} {...inputProps} />
    </Root>
  )
}

const Root = styled.div`
  height: 40px;
  background: #0d0d0d;
  border-radius: 12px;

  display: flex;
  align-items: center;
  padding-inline: 16px;

  color: var(--text-12);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`

const StyledInput = styled.input`
  width: 100%;
  height: 100%;
  padding: 0;
  outline: none;
  border: none;
  background: transparent;

  color: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;

  &::placeholder {
    color: var(--text-9);
  }
`
